var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-checkbox',{ref:"c-noId",attrs:{"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input', value); }}},[_c('span',{domProps:{"textContent":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }